// StudioOS navigation guard: links from the homepage Staff Pick should
// always open the product at the top, never at a restored iOS scroll position.
(() => {
  const KEY = 'studioos-open-product-at-top';
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.ez-hero-spotlight a[href*="/products/"]');
    if (link) sessionStorage.setItem(KEY, '1');
  }, true);

  const resetProductScroll = () => {
    if (!document.querySelector('[data-studioos-product]')) return;
    if (sessionStorage.getItem(KEY) !== '1') return;
    sessionStorage.removeItem(KEY);
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    window.scrollTo(0, 0);
    requestAnimationFrame(() => window.scrollTo(0, 0));
    window.setTimeout(() => window.scrollTo(0, 0), 120);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resetProductScroll, { once: true });
  } else {
    resetProductScroll();
  }
})();

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-description-preview]').forEach((preview) => {
    const content = preview.querySelector('[data-description-content]');
    const button = preview.querySelector('[data-description-toggle]');
    if (!content || !button) return;

    const updateVisibility = () => {
      const needsToggle = content.scrollHeight > content.clientHeight + 4 || preview.classList.contains('is-expanded');
      button.hidden = !needsToggle;
    };

    button.addEventListener('click', () => {
      const expanded = preview.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      button.textContent = expanded ? 'Show less' : 'Read more';
      updateVisibility();
    });

    requestAnimationFrame(updateVisibility);
    window.addEventListener('resize', updateVisibility, { passive: true });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-studioos-product]').forEach((root) => {
    const productForm = root.querySelector('[data-product-form]');
    const variants = JSON.parse(root.querySelector('[data-product-json]')?.textContent || '[]');
    const selects = [...root.querySelectorAll('[data-option-select]')];
    const idInput = root.querySelector('[data-variant-id]');
    const quantityInput = root.querySelector('[data-quantity-input]');
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-product-compare]');
    const mobilePrice = root.querySelector('[data-mobile-price]');
    const submit = root.querySelector('[data-product-submit]');
    const submitLabel = root.querySelector('[data-submit-label]');
    const submitPrice = root.querySelector('[data-submit-price]');
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: 'GBP' });

    const normaliseQuantity = () => {
      if (!quantityInput) return 1;
      const parsed = Math.floor(Number(quantityInput.value));
      const value = Number.isFinite(parsed) && parsed >= 1 ? parsed : 1;
      quantityInput.value = String(value);
      return value;
    };

    const selectedVariant = () => {
      const values = selects.map((select) => select.value);
      return variants.find((variant) => variant.options.every((option, index) => option === values[index]));
    };

    const showVariantMedia = (variant) => {
      if (!variant?.featured_media?.id) return;
      const slide = root.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
      if (!slide) return;
      const slides = [...root.querySelectorAll('[data-gallery-slide]')];
      const index = slides.indexOf(slide);
      if (index >= 0) showGallery(index);
    };

    const updateVariant = () => {
      const variant = selectedVariant();
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      const formatted = money.format(variant.price / 100);
      if (price) price.textContent = formatted;
      if (mobilePrice) mobilePrice.textContent = formatted;
      if (submitPrice) submitPrice.textContent = variant.available ? formatted : '';
      if (compare) {
        compare.hidden = !(variant.compare_at_price > variant.price);
        compare.textContent = variant.compare_at_price ? money.format(variant.compare_at_price / 100) : '';
      }
      if (submit) submit.disabled = !variant.available;
      if (submitLabel) submitLabel.textContent = variant.available ? 'Add to bag' : 'Sold out';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
      showVariantMedia(variant);
    };

    root.querySelectorAll('[data-option-group]').forEach((group, index) => {
      const select = selects[index];
      group.querySelectorAll('[data-option-value]').forEach((chip) => {
        chip.addEventListener('click', () => {
          group.querySelectorAll('[data-option-value]').forEach((item) => {
            item.classList.remove('is-selected');
            item.setAttribute('aria-pressed', 'false');
          });
          chip.classList.add('is-selected');
          chip.setAttribute('aria-pressed', 'true');
          if (select) select.value = chip.dataset.optionValue;
          const label = group.querySelector('[data-option-label]');
          if (label) label.textContent = chip.dataset.optionValue;
          updateVariant();
        });
      });
    });
    selects.forEach((select) => select.addEventListener('change', updateVariant));

    root.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      if (!quantityInput) return;
      quantityInput.value = String(Math.max(1, normaliseQuantity() - 1));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
    root.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      if (!quantityInput) return;
      quantityInput.value = String(normaliseQuantity() + 1);
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
    quantityInput?.addEventListener('input', () => {
      quantityInput.value = quantityInput.value.replace(/[^0-9]/g, '');
    });
    quantityInput?.addEventListener('blur', normaliseQuantity);

    const refreshCartCount = async () => {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());
      document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    };

    productForm?.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopPropagation();
      const variant = selectedVariant() || variants.find((item) => String(item.id) === idInput?.value);
      if (!variant?.available || !submit) return;
      normaliseQuantity();
      const oldLabel = submitLabel?.textContent || 'Add to bag';
      submit.disabled = true;
      if (submitLabel) submitLabel.textContent = 'Adding…';
      try {
        const shopRoot = window.Shopify?.routes?.root || '/';
        const formData = new FormData(productForm);
        formData.set('sections', 'ez-cart-drawer');
        formData.set('sections_url', `${shopRoot}cart`);
        const response = await fetch(`${shopRoot}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'Cache-Control': 'no-cache' },
          credentials: 'same-origin',
          cache: 'no-store',
          body: formData
        });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(payload.description || 'Cart add failed');
        if (submitLabel) submitLabel.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('studioos:cart:refresh', {
          detail: {
            open: true,
            source: 'product-form',
            message: 'Product added to your bag',
            sectionHtml: payload.sections?.['ez-cart-drawer'] || ''
          }
        }));
      } catch (error) {
        if (submitLabel) submitLabel.textContent = 'Try again';
      } finally {
        window.setTimeout(() => {
          submit.disabled = !variant.available;
          if (submitLabel) submitLabel.textContent = oldLabel;
        }, 1400);
      }
    });
    root.querySelector('[data-mobile-atc]')?.addEventListener('click', () => productForm?.requestSubmit(submit));

    const slides = [...root.querySelectorAll('[data-gallery-slide]')];
    const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
    const count = root.querySelector('[data-gallery-count]');
    let galleryIndex = 0;
    function showGallery(index) {
      if (!slides.length) return;
      galleryIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, itemIndex) => {
        const active = itemIndex === galleryIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      thumbs.forEach((thumb, itemIndex) => {
        const active = itemIndex === galleryIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (count) count.textContent = `${galleryIndex + 1} / ${slides.length}`;
      // Keep thumbnail movement horizontal only. scrollIntoView() can also move
      // the whole page vertically on iOS Safari, making product links open near
      // the Recently viewed section instead of at the product top.
      const activeThumb = thumbs[galleryIndex];
      const thumbRail = activeThumb?.parentElement;
      if (activeThumb && thumbRail && thumbRail.scrollWidth > thumbRail.clientWidth) {
        const targetLeft = activeThumb.offsetLeft - ((thumbRail.clientWidth - activeThumb.offsetWidth) / 2);
        thumbRail.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
      }
    }
    root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showGallery(galleryIndex - 1));
    root.querySelector('[data-gallery-next]')?.addEventListener('click', () => showGallery(galleryIndex + 1));
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showGallery(Number(thumb.dataset.index))));
    root.querySelector('[data-product-gallery]')?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') showGallery(galleryIndex - 1);
      if (event.key === 'ArrowRight') showGallery(galleryIndex + 1);
    });
    let touchX = 0;
    root.querySelector('[data-gallery-stage]')?.addEventListener('touchstart', (event) => { touchX = event.touches[0].clientX; }, { passive: true });
    root.querySelector('[data-gallery-stage]')?.addEventListener('touchend', (event) => {
      const distance = event.changedTouches[0].clientX - touchX;
      if (Math.abs(distance) > 45) showGallery(galleryIndex + (distance < 0 ? 1 : -1));
    }, { passive: true });

    const lightbox = root.querySelector('[data-product-lightbox]');
    const lightboxContent = root.querySelector('[data-lightbox-content]');
    root.querySelectorAll('[data-gallery-zoom]').forEach((button) => button.addEventListener('click', () => {
      const image = button.closest('[data-gallery-slide]')?.querySelector('img');
      if (!image || !lightboxContent || !lightbox) return;
      lightboxContent.innerHTML = '';
      const clone = image.cloneNode();
      clone.removeAttribute('loading');
      lightboxContent.appendChild(clone);
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }));
    const closeLightbox = () => {
      lightbox?.classList.remove('is-open');
      lightbox?.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };
    root.querySelector('[data-lightbox-close]')?.addEventListener('click', closeLightbox);
    lightbox?.addEventListener('click', (event) => { if (event.target === lightbox) closeLightbox(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeLightbox(); });


    const bulkOrder = root.querySelector('[data-bulk-order]');
    if (bulkOrder) {
      const bulkRows = [...bulkOrder.querySelectorAll('[data-bulk-row]')];
      const bulkCount = bulkOrder.querySelector('[data-bulk-count]');
      const bulkTotal = bulkOrder.querySelector('[data-bulk-total]');
      const bulkAdd = bulkOrder.querySelector('[data-bulk-add]');
      const bulkFooter = bulkOrder.querySelector('[data-bulk-footer]');
      const sticky = document.createElement('div');
      sticky.className = 'sos-bulk-sticky';
      sticky.innerHTML = '<div><small><span data-sticky-count>0</span> items selected</small><strong data-sticky-total>£0.00</strong></div><button type="button">Add selected to bag</button>';
      document.body.appendChild(sticky);
      const stickyCount = sticky.querySelector('[data-sticky-count]');
      const stickyTotal = sticky.querySelector('[data-sticky-total]');
      const stickyButton = sticky.querySelector('button');

      const normaliseBulk = (input) => {
        const parsed = Math.floor(Number(input.value));
        const value = Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
        input.value = String(value);
        return value;
      };

      const selectedBulkItems = () => bulkRows.map((row) => {
        const input = row.querySelector('[data-bulk-qty]');
        const quantity = input ? normaliseBulk(input) : 0;
        return {
          id: Number(row.dataset.variantId),
          quantity,
          price: Number(row.dataset.variantPrice || 0),
          available: row.dataset.variantAvailable === 'true'
        };
      }).filter((item) => item.available && item.quantity > 0);

      const updateBulkSummary = () => {
        const items = selectedBulkItems();
        const countValue = items.reduce((sum, item) => sum + item.quantity, 0);
        const totalValue = items.reduce((sum, item) => sum + (item.price * item.quantity), 0);
        const formatted = money.format(totalValue / 100);
        if (bulkCount) bulkCount.textContent = String(countValue);
        if (bulkTotal) bulkTotal.textContent = formatted;
        if (bulkAdd) bulkAdd.disabled = countValue === 0;
        if (stickyCount) stickyCount.textContent = String(countValue);
        if (stickyTotal) stickyTotal.textContent = formatted;
        const footerVisible = bulkFooter ? (bulkFooter.getBoundingClientRect().top < window.innerHeight && bulkFooter.getBoundingClientRect().bottom > 0) : false;
        sticky.classList.toggle('is-visible', countValue > 0 && !footerVisible);
        stickyButton.disabled = countValue === 0;
        bulkRows.forEach((row) => {
          const input = row.querySelector('[data-bulk-qty]');
          row.classList.toggle('is-selected', Number(input?.value || 0) > 0);
        });
      };

      bulkRows.forEach((row) => {
        const input = row.querySelector('[data-bulk-qty]');
        row.querySelector('[data-bulk-minus]')?.addEventListener('click', () => {
          if (!input) return;
          input.value = String(Math.max(0, normaliseBulk(input) - 1));
          updateBulkSummary();
        });
        row.querySelector('[data-bulk-plus]')?.addEventListener('click', () => {
          if (!input) return;
          input.value = String(normaliseBulk(input) + 1);
          updateBulkSummary();
        });
        input?.addEventListener('input', () => {
          input.value = input.value.replace(/[^0-9]/g, '');
          updateBulkSummary();
        });
        input?.addEventListener('blur', () => { normaliseBulk(input); updateBulkSummary(); });
        input?.addEventListener('focus', () => requestAnimationFrame(() => input.select()));
      });

      const shopRoot = window.Shopify?.routes?.root || '/';
      const cartAddUrl = `${shopRoot}cart/add.js`;

      const addOneCartItem = async ({ id, quantity }) => {
        const body = new URLSearchParams();
        body.set('id', String(id));
        body.set('quantity', String(quantity));
        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          },
          body: body.toString()
        });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(payload.description || payload.message || `Unable to add variant ${id}`);
        }
        return payload;
      };

      const addBulkItems = async () => {
        const items = selectedBulkItems().map(({ id, quantity }) => ({ id: String(id), quantity }));
        if (!items.length) return;
        const buttons = [bulkAdd, stickyButton].filter(Boolean);
        const labels = buttons.map((item) => item.textContent);
        buttons.forEach((item) => { item.disabled = true; item.textContent = 'Adding…'; });

        try {
          // First use Shopify's multi-item AJAX cart endpoint.
          let response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'Cache-Control': 'no-cache' },
            credentials: 'same-origin',
            cache: 'no-store',
            body: JSON.stringify({ items, sections: ['ez-cart-drawer'], sections_url: `${shopRoot}cart` })
          });

          let payload = await response.json().catch(() => ({}));
          if (!response.ok) {
            // Some storefront/app combinations reject multi-item JSON requests.
            // Fall back to adding each selected variant through Shopify's standard form endpoint.
            for (const item of items) await addOneCartItem(item);
            payload = {};
          }

          await refreshCartCount();
          bulkRows.forEach((row) => {
            const input = row.querySelector('[data-bulk-qty]');
            if (input) input.value = '0';
          });
          updateBulkSummary();
          buttons.forEach((item) => { item.textContent = 'Added ✓'; });

          document.dispatchEvent(new CustomEvent('studioos:cart:refresh', {
            detail: {
              open: true,
              source: 'bulk-order',
              message: 'Selected products added to your bag',
              sectionHtml: payload.sections?.['ez-cart-drawer'] || ''
            }
          }));
        } catch (error) {
          console.error('StudioOS bulk cart error:', error);
          const message = error instanceof Error && error.message ? error.message : 'Could not add selected items';
          buttons.forEach((item) => { item.textContent = message.length > 32 ? 'Could not add items' : message; });
        } finally {
          window.setTimeout(() => {
            buttons.forEach((item, index) => { item.disabled = false; item.textContent = labels[index]; });
            updateBulkSummary();
          }, 2200);
        }
      };

      bulkAdd?.addEventListener('click', addBulkItems);
      stickyButton?.addEventListener('click', addBulkItems);
      bulkOrder.addEventListener('toggle', () => {
        if (bulkOrder.classList.contains('sos-bulk-order--primary') && !bulkOrder.open) {
          bulkOrder.open = true;
        }
        updateBulkSummary();
      });
      window.addEventListener('scroll', updateBulkSummary, { passive: true });
      window.addEventListener('resize', updateBulkSummary);
      updateBulkSummary();
    }

    root.querySelector('[data-setup-form]')?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const items = [...event.currentTarget.querySelectorAll('input:checked')].map((input) => ({ id: Number(input.value), quantity: 1 }));
      if (!items.length) return;
      const button = event.currentTarget.querySelector('button');
      const old = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding setup…';
      try {
        const setupRoot = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${setupRoot}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'Cache-Control': 'no-cache' }, credentials: 'same-origin', cache: 'no-store', body: JSON.stringify({ items, sections: ['ez-cart-drawer'], sections_url: `${setupRoot}cart` }) });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(payload.description || 'Setup add failed');
        await refreshCartCount();
        button.textContent = 'Setup added ✓';
        document.dispatchEvent(new CustomEvent('studioos:cart:refresh', {
          detail: {
            open: true,
            source: 'product-engine',
            message: 'Product added to your bag',
            sectionHtml: payload.sections?.['ez-cart-drawer'] || ''
          }
        }));
      } catch (error) {
        button.textContent = 'Try again';
      } finally {
        window.setTimeout(() => { button.disabled = false; button.textContent = old; }, 1500);
      }
    });

    updateVariant();
  });
});










document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-native-recommend]').forEach((section) => {
    const scroller = section.querySelector('[data-native-recommend-scroller]');
    const prev = section.querySelector('[data-native-recommend-prev]');
    const next = section.querySelector('[data-native-recommend-next]');

    if (!scroller) return;

    const amount = () => Math.max(260, scroller.clientWidth * 0.82);

    prev?.addEventListener('click', () => {
      scroller.scrollBy({ left: -amount(), behavior: 'smooth' });
    });

    next?.addEventListener('click', () => {
      scroller.scrollBy({ left: amount(), behavior: 'smooth' });
    });

    scroller.addEventListener('wheel', (event) => {
      if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
      event.preventDefault();
      scroller.scrollLeft += event.deltaX;
    }, { passive: false });
  });
});


/* =========================================================
   StudioOS v1.4 — COMPLETE YOUR SETUP TOTALS
   ========================================================= */
(() => {
  const formatMoney = (pence) => {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(pence, window.theme?.moneyFormat || '£{{amount}}');
    }
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format((Number(pence) || 0) / 100);
  };

  const updateSetup = (section) => {
    if (!section) return;

    const checked = [...section.querySelectorAll('[data-setup-item-input]:checked')];
    const total = checked.reduce((sum, input) => sum + (Number(input.dataset.price) || 0), 0);

    const countNode = section.querySelector('[data-setup-count]');
    const totalNode = section.querySelector('[data-setup-total]');
    const submit = section.querySelector('[data-setup-submit]');

    if (countNode) countNode.textContent = String(checked.length);
    if (totalNode) totalNode.textContent = formatMoney(total);
    if (submit) submit.disabled = checked.length === 0;
  };

  const syncCurrentVariant = (section) => {
    const productRoot = section.closest('[data-product-root]');
    const variantInput = productRoot?.querySelector('[data-variant-id]');
    const variants = JSON.parse(productRoot?.querySelector('[data-product-json]')?.textContent || '[]');
    const variant = variants.find((item) => String(item.id) === String(variantInput?.value));
    const current = section.querySelector('[data-setup-current]');

    if (!variant || !current) return;

    current.value = String(variant.id);
    current.dataset.price = String(variant.price || 0);
    current.disabled = !variant.available;

    if (!variant.available) current.checked = false;

    const price = section.querySelector('[data-setup-current-price]');
    if (price) price.textContent = formatMoney(variant.price || 0);

    updateSetup(section);
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-complete-setup]').forEach((section) => {
      if (section.dataset.setupEnhanced === 'true') return;
      section.dataset.setupEnhanced = 'true';

      section.addEventListener('change', (event) => {
        if (event.target.matches('[data-setup-item-input]')) updateSetup(section);
      });

      const productRoot = section.closest('[data-product-root]');
      productRoot?.addEventListener('click', () => {
        window.setTimeout(() => syncCurrentVariant(section), 0);
      });
      productRoot?.addEventListener('change', () => {
        window.setTimeout(() => syncCurrentVariant(section), 0);
      });

      syncCurrentVariant(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once:true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
